// extracted by mini-css-extract-plugin
export default {"host":"style_host__cR4yl","tabSection":"style_tabSection__PU4X5","roleTabs":"style_roleTabs__jdJwG","tabBody":"style_tabBody__GfT3R"};